// Разворачивает картинку на всё доступное пространство в контейнере
const spreadIntoContainer = (img, container) => {
    if (!img) {
        return;
    }
    if (!container) {
        container = img.offsetParent;
        return setTimeout(() => {
            spreadIntoContainer(img, container);
        }, 1000 / 16);
    }

    container.ratio = container.clientWidth / container.clientHeight;
    if (img.ratio === undefined) {
        img.ratio = (img.naturalWidth || img.width) / (img.naturalHeight || img.height);
    }

    const newStyles = {
        width: '100%',
        height: '100%',
        marginTop: '0',
        marginLeft: '0',
    };

    if (img.ratio > container.ratio) {
        // случай: высота картинки меньше высоты контейнера
        const imgMarginLeft = (container.clientHeight * img.ratio - container.clientWidth) / -2;

        newStyles.width = 'auto';
        newStyles.marginLeft = `${imgMarginLeft}px`;
    } else {
        // случай: ширина картинки меньше ширины контейнера
        const imgMarginTop = (container.clientWidth / img.ratio - container.clientHeight) / -2;

        newStyles.height = 'auto';
        newStyles.marginTop = `${imgMarginTop}px`;
    }

    img.spreaded = true;
    Object.assign(img.style, newStyles);
};

export default spreadIntoContainer;
